import { render, staticRenderFns } from "./new-attribute-modal.vue?vue&type=template&id=fdd8ab4e"
import script from "./new-attribute-modal.vue?vue&type=script&lang=js"
export * from "./new-attribute-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports